export async function asyncForEach(arr, callback, context) {
  for(let index = 0; index < arr.length; index++) {
    await callback.call(context, arr[index], index, arr);
  }
}

export function averageOfKey(arr, key) {
  const sum = arr.reduce(function(carry, x) {
      return carry += x[key];
  }, 0);

  return Math.round(sum / arr.length);
}

export function debounce(callback, interval) {
  let debounceTimeout;

  return function(...args) {
    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(() => {
      callback.apply(this, args)
    }, interval);
  };
}

export function dispatchInputEvent(el, eventName, bubbles, cancelable) {
  let e = document.createEvent('Event');

  bubbles = (typeof bubbles !== 'undefined') ? bubbles : true;
  cancelable = (typeof cancelable !== 'undefined') ? cancelable : false;

  e.initEvent(eventName, bubbles, cancelable);

  el.dispatchEvent(e);
}

export function formatDate(date) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  date = new Date(date);

  return months[date.getMonth()] + ' '
          + date.getDate() + ', '
          + date.getFullYear();
}

export function formattedPrice(price) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  if(!Array.isArray(price)) {
    return formatter.format(price);
  }

  return price.map(p => formatter.format(p)).join(' &ndash; ');
}

export function getNestedProperty(nestedObj, pathArr) {
  return pathArr.reduce((obj, key) => {
      return (obj && obj[key] !== 'undefined') ? obj[key] : undefined;
    },
    nestedObj
  );
}

export function packageQty(uom) {
  uom = uom || '';

  if(uom.toUpperCase() === 'EACH') {
    return 1;
  }

  return Math.max(1, Number(uom.replace('PKG ', '')));
}

export function pick(obj, keys) {
  return Object.keys(obj)
      .filter(key => keys.indexOf(key) >= 0)
      .reduce((acc, key) => {
        acc[key] = obj[key];

        return acc;
      }, {});
}

export function randomString(len) {
  len = len || 40;
  return [...Array(len)].map(()=>(~~(Math.random()*36)).toString(36)).join('');
}

export function roundUp(value, step) {
  step = Number(step) || 1;

  if(value < step) {
    return step;
  }

  if(value % step !== 0) {
    return step * Math.ceil(value / step);
  }

  return value;
}

export function safeLabel(str) {
  return str.toLowerCase()
          .replace(/[^a-z0-9-_ ]/i, '')
          .replace(' ', '_');
}

export function setMinimumNumber(e, num) {
  if(e.target.value === '' || e.target.value < 1) {
    e.target.value = Number(num);

    let event = document.createEvent('Event');
    event.initEvent('input', true, true);
    e.target.dispatchEvent(event);
  }
}

export function startSequence(sequence) {
  const padding = this.scrapie === true ? 4 : 2;
  const prefix = (sequence || {}).prefix || '';
  const start = (sequence || {}).start || '';

  return prefix + String(start).padStart(padding, '0').substr(-6 + prefix.length);
}

export function throttle(callback, interval) {
  let throttleTimeout;
  let enableRun = true;

  return function(...args) {
    if(enableRun) {
      callback.apply(this, args);

      enableRun = false;

      throttleTimeout = setTimeout(() => enableRun = true, interval);
    } else {
      clearTimeout(throttleTimeout);

      throttleTimeout = setTimeout(function() {
        callback.apply(this, args);

        enableRun = true;
      }, interval);
    }
  }
}

export function ucfirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export class EartagPreview {
  constructor(
    side,
    template,
    srcDimensions = { width: 400, height: 400 },
    previewDimensions = { width: 300, height: 300 }
  ) {
    this.side = side;
    this.template = template;

    this.srcDrawWidth = srcDimensions.width;
    this.srcDrawHeight = srcDimensions.height;
    this.readX = 0;
    this.readY = 0;
    this.writeWidth = previewDimensions.width;
    this.writeHeight = previewDimensions.height;

    if(this.template.crop_x) {
      this.srcDrawWidth = srcDimensions.width - (srcDimensions.width * (this.template.crop_x / 100) * 2);
      this.readX = (srcDimensions.width - this.srcDrawWidth) / 2;
      this.writeWidth = this.srcDrawWidth / srcDimensions.width * previewDimensions.width;
    }

    if(this.template.crop_y) {
      this.srcDrawHeight = srcDimensions.height - (srcDimensions.height * (this.template.crop_y / 100) * 2);
      this.readY = (srcDimensions.height - this.srcDrawHeight) / 2;
      this.writeHeight = this.srcDrawHeight / srcDimensions.height * previewDimensions.height;
    }
  }
}
